import { endPoints } from 'api/';
import { DELETE_ATTRIBUTE } from 'actions/types';

/**
 * @description Deletes attribute and all it's system generated sub-attributes.
 * @param {{
 * attributes: [{}]
 * company_id: string
 * }} payload
 * @returns Attribute object
 */
function remove(payload) {
  const { attributes } = payload;
  const itemId = attributes[0]?.entity_id;
  const names = attributes.map(function (attr) {
    return attr.attribute_name;
  });
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: DELETE_ATTRIBUTE,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        const attribute = await apiClient(endPoints.DELETE_ATTRIBUTE, payload);
        const result = {
          ...attribute,
          data: {
            ...attribute.data,
            response: {
              names,
              itemId,
              attributes: attribute.data.response,
            },
          },
        };
        return result;
      },
    };
    dispatch(action);
  };
}

export default remove;
